import type { IconData } from '@stacksjs/iconify-core'

export const wifiSignal4: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M503.785 124.254a432.02 432.02 0 0 0-495.57 0L8 124.4v27.437L237.778 480h36.444L504 151.841V124.4Zm-100.458-18.088L213.968 390.2l-24.076-34.38L362.877 92.583a396 396 0 0 1 40.45 13.583M286.4 79.278a400 400 0 0 1 43.232 5.631l-159.49 242.7l-26.536-37.9ZM123.963 261.664l-22.8-32.563l97.97-146.955a403 403 0 0 1 49.324-3.946Zm30.751-170.579l-73.253 109.88l-41.6-59.418a398.1 398.1 0 0 1 114.853-50.462M256 450.232l-22.331-31.892l199.315-298.972a402 402 0 0 1 39.16 22.179Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default wifiSignal4
